export default __webpack_public_path__ + "assets/logout.4ea189a1.svg";